// Týždeň dobrovoľníctva je jednorazová kampaň so špecifickými pravidlami.
// na základe tohto časového rozmedzia si môže používateľ vytvoriť projekt
// kde označí projekt "volunteerWeek.isEnabled" parametrom a hashtagom #tyzdenDobrovolnictva
// taktýto projekt má následne iné správanie ako obyčajný projekt
//
// ako príklad:
// - počet dobrovoľníkov je obmedzený
// - počet dobrovoľníkov sa znižuje pri každom prihlásení
// - projekt sa automaticky publikuje počas tohto časového rozmedzia
// - projekt sa automaticky odpublikuje na konci tohto časového rozmedzia
// - dobrovoľníci sa môžu prihlásiť len počas tohto časového rozmedzia

export const VOLUNTEERING_WEEK = {
    // Campaign topic automatically attached to volunteering week opportunities
    TOPIC: 'TyzdenDobrovolnictva',
    // Private preview route token shared with regional centers before the public launch
    PRIVATE_OPPORTUNITIES_TOKEN: '16aa3939-4b9d-44c1-a673-fbc987571cae',
    // First day when organizations can create volunteering week opportunities
    CREATION_START: new Date('2026-02-02'),
    // The date when the volunteering week starts (minimum start date for projects: set as minimal start date in project form)
    START: new Date('2026-05-18'),
    // The date when the volunteering week ends (formal end of campaign)
    END: new Date('2026-05-24'),
    // When opportunities are published and volunteers can start to apply
    PUBLISH_DATE: new Date('2026-04-20'),
    // Last day organizations can create opportunities
    CREATION_DEADLINE: new Date('2026-05-24')
}
